
const MissionStatement = () => {
  return (
    <div className="bg-no-repeat  bg-AdviceBg font-[Inter] bg-cover relative sm:mx-14 mb-10 border-t-2 border-t-blue-200">
      <div className="absolute inset-0 bg-[#02041ccf] "></div>
      <div className="relative z-10">
      <div className=" transform p-6 sm:p-20 flex flex-col items-center gap-8 text-white text-center">
        <div className="h-1 w-14 bg-[#004C97] sm:mb-5"></div>
        <h2 className="font-bold sm:text-7xl leading-[0.4] sm:leading-5 text-6xl font-[Tangerine]">
          Mission <br /> Statement
        </h2>
        <p className="text-sm sm:w-[50%] sm:mx-auto">
          Our mission is to cultivate a new generation of Quran reciters and
          scholars by ensuring that at least 100 students annually achieve
          proficiency in multiple Qira’at, receive authentic Ijazah, and develop
          a deep, structured connection to the Quran.
        </p>
      </div>
      </div>
    </div>
  );
};

export default MissionStatement;
